import base from '@/module/base/routes';
import route from '@/config/route';

/**
 * meta: {
 *  title: {String}
 *  icon: (-) 菜单图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  noAuth: (false) 不验证权限、不同步到后台、不显示菜单
 *  noMenu: (false) 不显示为菜单
 * }
 */

const pages = [...base, ...route];
export default pages;
